import { Type } from 'class-transformer';
import {
  IsNotEmpty,
  IsArray,
  IsDateString,
  IsString,
  IsOptional,
  IsIn,
  ValidateNested,
} from 'class-validator';

import { CreateVacationUnitDto } from './create-vacation-unit.dto';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationMainDto {
  @IsArray()
  @Type(() => String)
  @IsOptional()
  companyIds: string[];

  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  activeTo: string;

  @IsString()
  @IsNotEmpty(notEmptyOptions)
  addPreviousVacation: string;

  @IsIn(['unit', 'company'])
  @IsString()
  @IsOptional()
  target?: 'unit' | 'company';

  @IsIn(['legal', 'operational'])
  @IsString()
  @IsOptional()
  unit_type?: 'legal' | 'operational';

  @ValidateNested({ each: true })
  @Type(() => CreateVacationUnitDto)
  @IsArray()
  @IsOptional()
  unit_items?: CreateVacationUnitDto[];
}
